import { render, staticRenderFns } from "./UpdateBulkCollection.vue?vue&type=template&id=6972329f&scoped=true&"
import script from "./UpdateBulkCollection.vue?vue&type=script&lang=js&"
export * from "./UpdateBulkCollection.vue?vue&type=script&lang=js&"
import style0 from "./UpdateBulkCollection.vue?vue&type=style&index=0&id=6972329f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6972329f",
  null
  
)

export default component.exports